// Sección CLASE (placeholder) · Vista en sala.
//
// El MÓDULO DE DISEÑO DE CLASE (definido por la directora técnica en el CRM) está
// PENDIENTE DE DESARROLLO. La Vista en sala solo lo CONSUME (lectura) cuando exista.
// Aquí queda el botón/sección visible + el HUECO DE LECTURA preparado: en cuanto el
// módulo publique el diseño de la clase, se lee desde aquí (cargarClaseDelDia).
//
// El agente VISTA-SALA NO construye el módulo de diseño de clase.

import React from "react";

const ClasePlaceholder = () => (
  <div className="vs-clase-placeholder">
    <h2>Clase</h2>
    <p className="vs-clase-prox">Próximamente</p>
    <p className="vs-clase-desc">
      Aquí se mostrará <b>la clase definida y diseñada por la directora técnica</b> en
      el CRM. El módulo de diseño de clase está en desarrollo; esta sección lo leerá
      en cuanto esté publicado.
    </p>
  </div>
);

export default ClasePlaceholder;
